/**
 * Environment Configuration
 * 
 * Centralized environment variable access with fallbacks for robustness.
 * All environment variables should be accessed through this file.
 * 
 * For production deployment:
 * - Set VITE_* variables in Cloudflare Pages environment variables
 * - Fallbacks ensure the app works even if env vars aren't set
 */

export const ENV = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://npm.rapidfix.ie',
  APP_URL: import.meta.env.VITE_APP_URL || 'https://rapidfix.ie',
  
  // Brand Configuration
  BRAND_NAME: import.meta.env.VITE_BRAND_NAME || 'RapidFix',
  BRAND_EMAIL: import.meta.env.VITE_BRAND_EMAIL || 'support@rapidfix.ie',
  BRAND_TAGLINE: import.meta.env.VITE_BRAND_TAGLINE || 'Your Trusted Service Platform',
  
  // Feature Flags
  MAINTENANCE_MODE: import.meta.env.VITE_MAINTENANCE_MODE === 'true',
  ENABLE_TESTING: import.meta.env.VITE_ENABLE_TESTING === 'true',
  ENABLE_WEBSOCKET: import.meta.env.VITE_ENABLE_WEBSOCKET === 'true',
  ENABLE_PUSH_NOTIFICATIONS: import.meta.env.VITE_ENABLE_PUSH_NOTIFICATIONS === 'true',
  
  // Environment Detection
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  MODE: import.meta.env.MODE,
} as const;

// Type-safe environment variable access
export type Environment = typeof ENV;
